import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
  { key: 'ID', label: 'id', type: 'number', defaultShow: true },
  { key: 'SHIPPER', label: 'shipper', type: 'select', selectOption: 'shipperCodes', defaultShow: true },
  { key: 'COT', label: 'cot', defaultShow: true },
  { key: 'CREATED_AT', label: 'createdAt', type: 'dateTime', defaultShow: true },
  { key: 'UPDATED_AT', label: 'updatedAt', type: 'dateTime', defaultShow: true },
];

